import { useEffect } from "react";
import type { ReactNode } from "react";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  wide?: boolean;
}

export function Modal({ open, onClose, title, children, footer, wide }: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="modal-overlay" onMouseDown={onClose} role="dialog" aria-modal="true">
      <div
        className={`modal ${wide ? "modal--wide" : ""}`.trim()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {title && (
          <div className="row row--between modal__title">
            <h2 style={{ margin: 0 }}>{title}</h2>
            <button className="toast__close" onClick={onClose} aria-label="Close">
              ✕
            </button>
          </div>
        )}
        <div className="stack">{children}</div>
        {footer && (
          <div className="row" style={{ marginTop: "var(--space-4)", justifyContent: "flex-end" }}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
